export type MbbCartSettings = {
  isBusiness: boolean;
  maxOrders: number;
  shippingPrice: number;
};

const firstAttribute = (elements: Element[], name: string): string | undefined =>
  elements.find((element) => element.getAttribute(name))?.getAttribute(name) ?? undefined;

export const readMbbCartSettings = (elements: Element[]): MbbCartSettings | undefined => {
  if (elements.length === 0) return undefined;

  const maxBundle = parseInt(firstAttribute(elements, "max-order-bundle") ?? "", 10);
  const shippingPrice = parseInt(firstAttribute(elements, "shipping-price") ?? "", 10);

  return {
    isBusiness: firstAttribute(elements, "is-inside-business") === "true",
    maxOrders: Number.isNaN(maxBundle) || maxBundle < 1 ? 5 : maxBundle,
    shippingPrice: Number.isNaN(shippingPrice) ? 79 : shippingPrice,
  };
};
